module.exports = __webpack_public_path__ + "img/KSC02742.27497cdc.jpg";